import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import style from './style.css'

export default function Clickable (props) {
  if (props.disabled) {
    return (
      <span {...props}>
        {props.children}
      </span>
    )
  } else {
    return (
      <a
        {...props}
        className={classnames(style.base, props.className, style.colorInherit)}
        role="button"
        tabIndex="0"
      >
        {props.children}
      </a>
    )
  }
}

Clickable.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool
}
